import React from 'react';

import Image from '../../../../library/image/image';

function FuelEfficiencyImage() {
  return (
    <Image
      alt="Fuel Efficiency"
      height="22"
      src="https://discounttire.scene7.com/is/content/discounttire/logos/icons/treadwell-gray-tire-leaf.svg"
      width="22"
    />
  );
}

export default FuelEfficiencyImage;
